{
  "options": {
    "errors": {
      "accessReject": "У вас нет доступа к опционам",
      "notFoundOption": "Опцион не найден",
      "failCreateOrder": "Не удалось создать ордер"
    },
    "empty": "Нет опционов по данному тикеру",
    "stockPrice": "Цена акции:",
    "columns": {
      "strike": "Страйк",
      "bid": "Bid",
      "ask": "Ask",
      "last": "Цена",
      "change": "Сегодня %",
      "breakeven": "Безубыток",
      "volatility": "Импл. Вол.",
      "interest": "Откр. инт.",
      "delta": "Дельта",
      "gamma": "Гамма",
      "theta": "Тэта",
      "vega": "Вега"
    },
    "actions": {
      "trade": "Торговать",
      "info": "Инфо"
    }
  }
}
